export default "__VITE_ASSET__QUzWBafY__"